/**
 * deriveVerdictPhrase — compute the four cockpit verdict phrases from existing
 * Deal Screen output fields. This is a frontend-only derivation — it does NOT
 * introduce a new field on startups.deal_screen and does NOT touch data_province.
 *
 * Authority: docs/agents/pitch-deck-review/pages/DEAL_EVALUATOR_PAGE_SPEC_V2.md
 *            Section 16.1 (WI-UI-CLEANUP-001 Stage 2, Decision-D1).
 *
 * Inputs the function reads off an inbox item:
 *   - item.payload.deal_screen.call_decision — 'worth_a_call' | 'not_worth_a_call' | undefined
 *     Backend enum: DealScreenCallDecision (backend/core/system/constants.py).
 *   - item.status — 'rejected' short-circuits to "Pass" regardless of call.
 *   - item.priority — 'High' | 'Normal' | 'Low' — from the work item envelope.
 *   - item.payload.confidence — number in [0,1] when present; null if absent.
 *
 * Output shape: { phrase, tone } where tone maps 1:1 to VERDICT_PILL keys.
 */

export function deriveVerdictPhrase(item) {
  const payload = (item && item.payload) || {};
  const ds = payload.deal_screen || {};
  const call = ds.call_decision;
  const priority = item && item.priority;
  const confidence = payload.confidence != null ? payload.confidence : null;

  if (call === 'not_worth_a_call' || (item && item.status === 'rejected')) {
    return { phrase: 'Pass', tone: 'unclear' };
  }
  if (call === 'worth_a_call' && priority === 'High') {
    return { phrase: 'Worth a call', tone: 'strong' };
  }
  if (call === 'worth_a_call') {
    return { phrase: 'Needs a second read', tone: 'moderate' };
  }
  if (
    priority === 'Normal'
    && confidence !== null
    && confidence >= 0.4
    && confidence <= 0.7
  ) {
    return { phrase: 'Directional', tone: 'weak' };
  }
  return { phrase: 'Directional', tone: 'weak' };
}

export default deriveVerdictPhrase;
